var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoForHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 781,
    height: 277,
    viewBox: "0 0 781 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-logo_-_1_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 781,
    height: 277
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_-_1_1",
    "data-name": "logo - 1 \\u2013 1",
    clipPath: "url(#clip-logo_-_1_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 781,
    height: 277,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Chain_Chaser",
    "data-name": "Chain Chaser",
    transform: "translate(0 138)",
    fontSize: 150,
    fontFamily: "Futura-Medium, Futura",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#102c67"
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "ain"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 123
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    y: 123,
    fill: "#102c68"
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    y: 123
  }, "aser")), /*#__PURE__*/React.createElement("text", {
    id: "Alpha_version",
    "data-name": "Alpha version",
    transform: "translate(520 258)",
    fill: "#102c68",
    fontSize: 40,
    fontFamily: "Futura-Medium, Futura",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Alpha version")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForHeader);
export default __webpack_public_path__ + "static/media/logoForHeader.d8685a87f399ce840c6de8d802464811.svg";
export { ForwardRef as ReactComponent };